/**
 * Client-side checks shared by the public forms, so the copies stop drifting apart.
 * Each mirrors a backend rule; the API still validates everything on submit.
 */

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

// Nome + sobrenome: at least two letter-words (allowing hyphens, apostrophes and
// abbreviation dots). Mirrors the API's ValidatesFullName rule.
const FULL_NAME_REGEX = /^\p{L}[\p{L}'’.-]*(?:\s+\p{L}[\p{L}'’.-]*)+$/u

export const hasFullName = (name: string): boolean => FULL_NAME_REGEX.test(name.trim())
